import React from "react";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import TimeAttendance from "./AttendanceCalender.";
import AttendanceTable from "./AttendanceTable";
import EmployeeAttendanceMobileView from "./EmployeeAttendanceMobileView";
import { getUserInfoFromToken } from "../../utils/authUtils";

const normalizeUserType = (type) => {
  if (!type) return null;
  const normalized = String(type).trim().toLowerCase();
  if (normalized === "employee") return "Employee";
  if (normalized === "employer") return "Employer";
  if (normalized === "admin") return "Admin";
  return type;
};

const Attendance = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"), { noSsr: true });
  const userType = normalizeUserType(getUserInfoFromToken().userType);

  if (userType === "Employee") {
    if (isMobile) {
      return <EmployeeAttendanceMobileView />;
    }
    return <TimeAttendance />;
  }

  if (userType === "Employer" || userType === "Admin") {
    return <AttendanceTable />;
  }

  return <div>User type not recognized. Please log in again.</div>;
};

export default Attendance;
